import {Injectable} from '@angular/core';
import {v4 as uuidv4} from 'uuid';
import {DateTime} from 'luxon';
import {db} from '../db.service';
import {VoiceRecording} from '../../interfaces/core/voice-recording';

@Injectable({
  providedIn: 'root'
})
export class VoiceRecordingsTable {

  public static readonly maxPendingVoiceRecordings = 10;

  /**
   *
   */
  public async getAll(): Promise<VoiceRecording[]> {
    return db.voiceRecordings.orderBy('created').reverse().toArray();
  }

  /**
   *
   */
  public async count(): Promise<number> {
    return db.voiceRecordings.count();
  }

  /**
   *
   * @param voiceRecording
   */
  public async add(voiceRecording: VoiceRecording): Promise<VoiceRecording> {
    voiceRecording.uuid = voiceRecording.uuid ? voiceRecording.uuid : uuidv4();
    voiceRecording.created = voiceRecording.created ? voiceRecording.created : DateTime.local().toISO();
    await db.voiceRecordings.add(voiceRecording);
    return voiceRecording;
  }

  /**
   *
   * @param voiceRecording
   */
  public async update(voiceRecording: VoiceRecording): Promise<VoiceRecording> {
    await db.voiceRecordings.put(voiceRecording);
    return voiceRecording;
  }

  /**
   * Transkribierte Aufnahmen von Vortagen löschen; nicht transkribierte
   * Aufnahmen bleiben erhalten, bis sie transkribiert oder manuell
   * gelöscht werden
   */
  public async pruneTranscribedFromPreviousDays(): Promise<void> {
    const startOfToday = DateTime.local().startOf('day');
    await db.voiceRecordings
      .filter((voiceRecording) => !!voiceRecording.transcription
        && DateTime.fromISO(voiceRecording.created) < startOfToday)
      .delete();
  }

  /**
   * Schutz vor unbegrenztem Wachstum: nicht transkribierte Aufnahmen
   * werden nie nach Alter gelöscht, aber nur die neuesten
   * `maxPendingVoiceRecordings` behalten. Lesen und Löschen laufen in
   * einer Transaktion, damit zwischenzeitlich transkribierte Aufnahmen
   * nicht gelöscht werden
   */
  public async prunePendingToLimit(): Promise<void> {
    await db.transaction('rw', db.voiceRecordings, async () => {
      const pendingVoiceRecordings = (await db.voiceRecordings.orderBy('created').reverse().toArray())
        .filter((voiceRecording) => !voiceRecording.transcription);

      const outdatedVoiceRecordings = pendingVoiceRecordings.slice(VoiceRecordingsTable.maxPendingVoiceRecordings);

      if (outdatedVoiceRecordings.length > 0) {
        await db.voiceRecordings.bulkDelete(outdatedVoiceRecordings.map((voiceRecording) => voiceRecording.uuid));
      }
    });
  }

  /**
   *
   * @param voiceRecordingUuid
   */
  public async remove(voiceRecordingUuid: string): Promise<void> {
    await db.voiceRecordings.delete(voiceRecordingUuid);
  }

}
